const useSuperpartnerConfigTable = () => {
  return [
    { key: 'nome', label: 'Nome Superpartner', hideOrder: false },
    { key: 'piva', label: 'P.IVA', hideOrder: false },
    { key: 'referente', label: 'Referente', hideOrder: true },
    { key: 'email', label: 'Email', hideOrder: false }
  ];
};
export default useSuperpartnerConfigTable;